/* PLAYTS Set-Rabatt per Code (Option 1, seit 2026-10).
 *
 * Konfigurator und Set-Karten legen die Einzelteile eines Sets mit den versteckten
 * Line-Properties _set (Set-ID) und _set_key („s1-o1-r1") in den Warenkorb. Dieses
 * Script hält die Set-Rabattcodes am Warenkorb passend:
 *   · je Set-ID zählt die TATSÄCHLICHE Zusammensetzung der Teile (Mengen im
 *     Warenkorb geändert → z. B. aus S+O+R wird S+O+2R); steht sie in der
 *     Preisliste: Rabatt = Summe der Teile − Set-Preis, sonst kein Rabatt,
 *   · dazu ein freier Code mit genau diesem Betrag (Bestell-Rabatt, stapelbar),
 *   · fremde Codes (Influencer, Gutscheine) bleiben unangetastet.
 * Läuft nach jedem Hinzufügen (PlaytsSetCodes.sync()), nach Mengenänderungen im
 * Warenkorb (theme:cartchanged) und beim Öffnen der Warenkorbseite.
 * Daten: Shop-Metafeld playts.set_prices (scripts/playts_set_codes.py), eingebettet
 * von snippets/playts-set-codes.liquid. */
(function () {
  'use strict';
  if (window.PlaytsSetCodes) return;

  var data = {};
  try {
    var el = document.querySelector('script[data-playts-set-codes]');
    data = JSON.parse(el ? el.textContent : '{}') || {};
  } catch (e) { data = {}; }
  var TYPES = data.types || {};
  var CODES = data.codes || {};
  var PREFIX = String(data.prefix || 'PLAYTS-SET-').toUpperCase();
  var MAX_CODES = 5; // Shopify: max. 5 Produkt-/Bestell-Codes je Bestellung
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function isSetCode(code) { return String(code || '').toUpperCase().indexOf(PREFIX) === 0; }

  function shapeOf(item) {
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      var v = String(opts[i].value || '').toLowerCase();
      if (v === 'square' || v === 'oval' || v === 'round') return v;
    }
    return null;
  }

  // Rabattbeträge (Cent) aller vollständigen Sets im Warenkorb, größte zuerst.
  function setDiscounts(cart) {
    var sets = {};
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (!p._set) return;
      var s = sets[p._set] || (sets[p._set] = { c: { square: 0, oval: 0, round: 0 }, sum: 0, ok: true });
      var sh = shapeOf(it);
      if (!sh) { s.ok = false; return; }
      s.c[sh] += it.quantity;
      s.sum += it.original_price * it.quantity;
    });
    var out = [];
    Object.keys(sets).forEach(function (id) {
      var s = sets[id];
      var price = TYPES['s' + s.c.square + '-o' + s.c.oval + '-r' + s.c.round];
      if (!s.ok || typeof price !== 'number') return;
      if (s.sum - price > 0) out.push(s.sum - price);
    });
    return out.sort(function (a, b) { return b - a; });
  }

  function pickCodes(amounts, budget) {
    var used = {}, out = [];
    amounts.forEach(function (d) {
      if (out.length >= budget) return;
      var pool = CODES[String(d)] || [];
      var i = used[d] || 0;
      if (i < pool.length) { out.push(pool[i]); used[d] = i + 1; }
      else { console.warn('PLAYTS Set-Rabatt: kein freier Code für', d / 100, '€'); }
    });
    return out;
  }

  function sameCodes(a, b) {
    if (a.length !== b.length) return false;
    var x = a.map(function (c) { return c.toUpperCase(); }).sort();
    var y = b.map(function (c) { return c.toUpperCase(); }).sort();
    return x.every(function (c, i) { return c === y[i]; });
  }

  function run() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var current = (cart.discount_codes || []).map(function (d) { return d.code; });
        var others = current.filter(function (c) { return !isSetCode(c); });
        var mine = current.filter(isSetCode);
        var want = pickCodes(setDiscounts(cart), Math.max(0, MAX_CODES - others.length));
        if (sameCodes(mine, want)) return false;
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: others.concat(want).join(',') })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart/update.js ' + r.status);
          return true;
        });
      })
      .catch(function (e) { console.error('PLAYTS Set-Rabatt:', e); return false; });
  }

  // Nacheinander, nie parallel (sonst überschreiben sich die Code-Listen).
  var queue = Promise.resolve(false);
  function sync() {
    queue = queue.then(run, run);
    return queue;
  }

  function refreshCartPage(changed) {
    if (!changed) return;
    document.querySelectorAll('cart-form').forEach(function (el) {
      if (typeof el.refresh === 'function') el.refresh();
    });
  }

  document.addEventListener('theme:cartchanged', function () { sync().then(refreshCartPage); });
  if (document.querySelector('cart-form')) sync().then(refreshCartPage);

  window.PlaytsSetCodes = {
    sync: sync,
    types: TYPES,
    // Line-Properties für alle Teile EINES Sets (neue ID je Hinzufügen).
    props: function (key) {
      return { _set: Date.now().toString(36) + Math.random().toString(36).slice(2, 6), _set_key: key };
    }
  };
})();
